
import { defineComponent, PropType, ref } from 'vue'

import Cheap from '@/common/components/UI/Cheap/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

import useNotifications from '@/common/composable/useNotifications'

import crmAPI from '@/new-services/crm.service'

export default defineComponent({
    components: {
        Cheap,
        TheButton,
    },
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
    },
    emits: ['update-task'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const is_send_to_call_loading = ref(false)

        const onUpdateTask = () => {
            emit('update-task', { ...props.row })
        }

        const formatDate = (dateStr: string) => {
            if (!dateStr) return '-'

            const dateFirst = dateStr.split(' ')[0]
            const dateSecond = dateStr.split(' ')[1]
            return dateFirst.split('-').reverse().join('.') + ' ' + dateSecond
        }

        const onSendToCall = async () => {
            if (is_send_to_call_loading.value) return

            const answer = confirm('Вы действительно хотите отправить задание на звонок?')
            if (!answer) return

            try {
                is_send_to_call_loading.value = true

                await crmAPI.sendTaskOnCall(props.row.id)

                notifications.notify({ type: 'success', title: 'Задание на звонок отправлено' })
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При отправке задания на звонок произошла ошибка',
                })
            } finally {
                is_send_to_call_loading.value = false
            }
        }

        return {
            onUpdateTask,
            is_send_to_call_loading,
            onSendToCall,
            formatDate,
        }
    },
})
